/**
 * Build the host-context payload the dashboard feeds the widget via
 * `window.syncanix.setContext(...)`. Grounds the assistant in WHERE the
 * signed-in user is (current route) and WHICH workspace they're operating in,
 * so a "what does this page do?" / "what's my plan?" question is answerable.
 *
 * Pure + deterministic. NEVER includes credentials/tokens — the context is sent
 * to the model and may appear in transcripts (`docs/runbooks/widget-embed.md` §
 * "Feeding live context"). The signed-in user's identity travels separately +
 * securely through the token provider, not here.
 */

export interface DashboardContextInput {
  /** Current route path (e.g. `/catalog`). */
  readonly pathname: string;
  /** Active workspace display name, if known. */
  readonly workspaceName?: string | null | undefined;
}

export interface DashboardWidgetContext {
  readonly surface: 'syncanix-dashboard';
  readonly page: { readonly path: string };
  readonly workspace?: { readonly name: string };
}

export function buildWidgetContext(input: DashboardContextInput): DashboardWidgetContext {
  const name = input.workspaceName?.trim();
  return {
    surface: 'syncanix-dashboard',
    page: { path: input.pathname },
    ...(name !== undefined && name !== '' ? { workspace: { name } } : {}),
  };
}
